import React from 'react';

interface Placeholder {
  label: string;
  url: string;
}

interface RenderTermsProps {
  template: string;
  placeholders: { [key: string]: Placeholder };
}

export const renderTermsTemplate = ({ template, placeholders }: RenderTermsProps): JSX.Element => {
  if (!template || !placeholders) {
    return <span>Loading terms...</span>;
  }

  // Split the template by placeholder markers (e.g., {terms})
  const parts = template.split(/\{(\w+)\}/);
  
  return (
    <>
      {parts.map((part, index) => {
        // If this part matches a placeholder key
        if (placeholders[part]) {
          const placeholder = placeholders[part];
          return (
            <a
              key={index}
              href={placeholder.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {placeholder.label}
            </a>
          );
        }
        // Regular text part
        return <span key={index}>{part}</span>;
      })}
    </>
  );
};

export default renderTermsTemplate;